import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import moment from 'moment';
import localization from 'moment/locale/th';
import axios from 'axios';
import {
  Card, CardContent, CardActions, Typography, Grid, Divider, Button, IconButton,
  TextField, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle
} from '@material-ui/core';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import GetAppIcon from '@material-ui/icons/GetApp';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import mockData from './image';
import Description from '@material-ui/icons/Description';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const useStyles = makeStyles(theme => ({
  root: {},
  imageContainer: {
    height: 64,
    width: 64,
    margin: '0 auto',
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: '5px',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  image: {
    width: '100%'
  },
  statsItem: {
    display: 'flex',
    alignItems: 'center'
  },
  statsIcon: {
    color: theme.palette.icon,
  }
}));

const ReportList = props => {
  const { className, report, budgetYears, typePersons, ...rest } = props;
  const classes = useStyles();
  const [images] = useState(mockData);
  const [newSlipData, setNewSlipData] = useState([]);
  const [open, setOpen] = useState(false);
  const [profile] = useState(JSON.parse(localStorage.getItem('profile')));
  const [dka_id, setDka_id] = useState('');
  const [dka_years, setDka_years] = useState('');
  const [dka_detail, setDka_detail] = useState('');
  const [tax_value, setTax_value] = useState(0);
  const [Finder_name, setFinder_name] = useState('');
  const [Finder_position, setFinder_position] = useState('');
  let source = axios.CancelToken.source();

  const loadPersonData = async () => {
    const url = 'https://eslip.snru.ac.th/backend/api/users/personsByType/13';
    const result = await axios(url, {
      cancelToken: source.token
    });
    return (result.data.data)
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const currencyFormat = num => {
    return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
  }

  const loadEslipReportConfig = async (reportTypeId) => {
    try {
      const url = 'https://eslip.snru.ac.th/backend/api/reportData/getByReportType/' + reportTypeId + '/1';
      const result = await axios(url, {
        cancelToken: source.token
      });
      return (result.data.data)
    } catch (error) {

    }
  };

  const loadEslipReport_7 = async (payfor) => {
    try {
      const url = 'https://eslip.snru.ac.th/backend/api/reportData/getByReport_7/' + payfor;
      const result = await axios(url, {
        cancelToken: source.token
      });
      return (result.data.data)
    } catch (error) {

    }
  };

  const loadEslipReportConfigByDkaId = async (dkaId, dkaYears, reportTypeId) => {
    try {
      const url = 'https://eslip.snru.ac.th/backend/api/reportData/getById/' + dkaId + "/" + dkaYears + "/" + reportTypeId;
      const result = await axios(url, {
        cancelToken: source.token
      });
      return (result.data.data)
    } catch (error) {

    }
  };

  const loadSlipData = async (payfor) => {
    try {
      const url = 'https://eslip.snru.ac.th/backend/api/eslipData/slipByPay/' + payfor;
      const result = await axios(url, {
        cancelToken: source.token
      });
      return (result.data.data)
    } catch (error) {

    }
  };

  const loadEtcData = async (payfor) => {
    try {
      const url = 'https://eslip.snru.ac.th/backend/api/eslipData/etcByPay/' + payfor;
      const result = await axios(url, {
        cancelToken: source.token
      });
      return (result.data.data)
    } catch (error) {
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        //setColumnsData(tableHeader);
        //loadData();
        let newslip = [];
        let curdate = moment().format('YYYY-MM') + '-01';
        const slipdata = await loadSlipData((budgetYears === '') ? curdate : budgetYears);
        const etcdata = await loadEtcData((budgetYears === '') ? curdate : budgetYears);
        const personData = await loadPersonData();

        const persons = personData.map(person => ({
          citizen_id: person.citizen_id,
          position_num: person.position_num,
          fullname: person.prefix_name + person.fnamethai + " " + person.lnamethai,
          position_name: person.position_name,
        }));

        persons.forEach(person => {
          const slips = slipdata.filter((slip) => {
            return slip.citizen_id === person.citizen_id
          })
          const etcs = etcdata.filter((etc) => {
            return etc.citizen_id === person.citizen_id
          })

          slips.forEach(slip => {
            person = { ...person, [slip.money_type_id]: currencyFormat(slip.eslip_value) }
          });

          etcs.forEach(etc => {
            person = { ...person, 'eslip_number': etc.auto_id, 'bank_name': etc.bank_name, 'bank_account': etc.bank_account, 'project_activities_id': etc.project_activities_id, 'etc': etc.etc }
          });

          newslip.push(person);
          setNewSlipData(newslip)
        });
      } catch (error) {
        console.log(error)
      }
    }
    fetchData()
    return () => {
      // source.cancel();
    };
  }, [budgetYears, report, typePersons]);

  const printSlip = async (reportTypeId) => {
    pdfMake.fonts = {
      THSarabunNew: {
        normal: 'THSarabunNew.ttf',
        bold: 'THSarabunNew-Bold.ttf',
        italics: 'THSarabunNew-Italic.ttf',
        bolditalics: 'THSarabunNew-BoldItalic.ttf'
      },
      Roboto: {
        normal: 'Roboto-Regular.ttf',
        bold: 'Roboto-Medium.ttf',
        italics: 'Roboto-Italic.ttf',
        bolditalics: 'Roboto-MediumItalic.ttf'
      },
      FontAwesome: {
        normal: 'fontawesome-webfont.ttf'
      }
    }

    if (reportTypeId === '4109-1') {
      let docDefinition = await report_4109_1(reportTypeId);
      pdfMake.createPdf(docDefinition).open();
    }
    else if (reportTypeId === '4109-2') {
      let docDefinition = await report_4109_2(reportTypeId);
      pdfMake.createPdf(docDefinition).open();
    }
    else if (reportTypeId === '4109-3') {
      let docDefinition = await report_4109_3(reportTypeId);
      pdfMake.createPdf(docDefinition).open();
    }
    else if (reportTypeId === '4109-31') {
      let docDefinition = await report_4109_31(reportTypeId);
      pdfMake.createPdf(docDefinition).open();
    }
    else if (reportTypeId === '4109-4') {

    }
    else if (reportTypeId === 'พมล. ปกส') {
      let docDefinition = await report_4109_5(reportTypeId);
      pdfMake.createPdf(docDefinition).open();
    }
    else if (reportTypeId === '4109-7') {
      let docDefinition = await report_4109_7(reportTypeId);
      pdfMake.createPdf(docDefinition).open();
    }
  }

  const report_4109_1 = async (reportTypeId) => {
    let list_person_name = [];
    let list_position_num = [];
    let list_position_name = [];
    let list_salary_value = [];
    let list_salary_total = [];
    let list_etc = [];
    let salary_value = [];
    let salary_total = [];

    const { dka_id, dka_years, dka_detail, tax_value, Finder_name, Finder_position } = await loadEslipReportConfig(reportTypeId);
    newSlipData.forEach(slip => {
      list_person_name.push(slip.fullname);
      list_position_num.push(slip.position_num);
      list_position_name.push(slip.position_name);

      if (slip.etc === undefined || slip.etc === null) {
        list_etc.push("\n");
      }
      else {
        list_etc.push(slip.etc);
      }
      if (slip[1] === undefined) {
        list_salary_value.push("-");
        list_salary_total.push("-");
      }
      else {
        list_salary_value.push(slip[1]);
        list_salary_total.push(slip[1]);
        salary_value.push(parseFloat(slip[1].replace(',', '')));
        salary_total.push(parseFloat(slip[1].replace(',', '')));
      }
    })
    const sum_salary_value = salary_value.reduce((a, b) => a + b, 0)
    const sum_total_salary = salary_total.reduce((a, b) => a + b, 0)

    let docDefinition = {
      pageSize: 'A4',
      pageOrientation: 'landscape',
      pageMargins: [20, 20, 20, 20],
      content: [
        {
          absolutePosition: { x: 600, y: 30 },
          columns: [
            {
              width: 150,
              text: [
                { text: 'ฎีกาที่ ', style: 'header2', alignment: 'left' },
                { text: dka_id + '/' + dka_years, style: 'header3', alignment: 'left' }
              ]
            }
          ]
        },
        {
          columns: [
            {
              width: 440,
              text: []
            },
            {
              width: 140,
              text: [
                { text: '\uf096  ', style: 'awesome', alignment: 'left' }, //{ text: '\uf046 ', style: 'awesome', alignment: 'right' },               
                { text: 'ประจำ', style: 'subheader', alignment: 'left' }
              ]
            },
            {
              width: 130,
              text: [
              ]
            },
            {
              width: 70,
              text: [
                { text: 'แบบ 4109', style: 'header', alignment: 'left' }
              ]
            }
          ]
        },
        {
          columns: [
            { width: 50, text: [] },
            { width: 120, text: [{ text: 'แบบแนบฎีกา', style: 'subheader', alignment: 'left' }] },
            { width: 120, text: [{ text: '\uf096  ', style: 'awesome', alignment: 'left' }, { text: 'เงินเดือน', style: 'subheader', alignment: 'left' }] },
            { width: 120, text: [{ text: '\uf096  ', style: 'awesome', alignment: 'left' }, { text: 'ค่าจ้าง', style: 'subheader', alignment: 'left' }] },
            { width: 140, text: [{ text: '\uf096  ', style: 'awesome', alignment: 'left' }, { text: 'ชั่วคราวรายเดือน', style: 'subheader', alignment: 'left' }] },
            { width: 130, text: [] },
            { width: 70, text: [] }
          ]
        },
        {
          columns: [
            { width: 440, text: [] },
            { width: 140, text: [{ text: '\uf096  ', style: 'awesome', alignment: 'left' }, { text: 'ชั่วคราวรายวัน', style: 'subheader', alignment: 'left' }] },
            { width: 55, text: [] },
            { width: 145, text: [{ text: '\uf096  ', style: 'awesome', alignment: 'left' }, { text: 'เบี้ยหวัดบำนาญ', style: 'subheader', alignment: 'left' }] }
          ]
        }, {
          columns: [
            { width: 100, text: [] },
            { width: 55, text: [{ text: 'ส่วนราชการ', style: 'subheader', alignment: 'left' }] },
            { width: 130, text: [{ text: 'มหาวิทยาลัยราชภักสกลนคร', style: 'header', alignment: 'left' }] },
            { width: 30, text: [{ text: 'จังหวัด', style: 'subheader', alignment: 'left' }] },
            { width: 50, text: [{ text: 'สกลนคร', style: 'header', alignment: 'left' }] },
            { width: 45, text: [] },
            { width: 80, text: [{ text: 'ประจำเดือน', style: 'subheader', alignment: 'left' }] },
            { width: 80, text: [{ text: moment(budgetYears).format('MMMM'), style: 'header', alignment: 'left' }] },
            { width: 20, text: [{ text: 'พ.ศ.', style: 'subheader', alignment: 'left' }] },
            { width: 225, text: [{ text: parseInt(moment(budgetYears).format('YYYY')) + 543, style: 'header', alignment: 'left' }] }
          ]
        },
        {
          columns: [
            {
              table: {
                widths: [45, 155, 150, 42, 60, 30, 50, 60, 120],
                //heights: [20, 400, 200, 200, 20, 20, 20, 20, 20],
                headerRows: 1,
                body: [
                  [
                    { text: 'เลขประจำ\nตำแหน่ง', style: 'tableHeader', alignment: 'center' },
                    { text: 'ชื่อ - สกุล/จำนวนอัตรา', style: 'tableHeader', alignment: 'center' },
                    { text: 'ตำแหน่ง', style: 'tableHeader', alignment: 'center' },
                    { text: 'ระดับ / \nขั้น', style: 'tableHeader', alignment: 'center' },
                    { text: 'ขั้น', style: 'tableHeader', alignment: 'center' },
                    { text: 'เบิกลด', style: 'tableHeader', alignment: 'center' },
                    { text: 'เงินเพิ่ม', style: 'tableHeader', alignment: 'center' },
                    { text: 'รวมเบิก', style: 'tableHeader', alignment: 'center' },
                    { text: 'หมายเหตุ', style: 'tableHeader', alignment: 'center' }
                  ],
                  [
                    { text: '', style: 'tableHeader', alignment: 'center' },
                    {
                      text: 'เงินเดือนพนักงานมหาวิทยาลัย', style: 'tableHeader3', alignment: 'center', colSpan: 2
                    }, {}, {},
                    { text: '', style: 'tableHeader', alignment: 'center' },
                    { text: '', style: 'tableHeader', alignment: 'center' },
                    { text: '', style: 'tableHeader', alignment: 'center' },
                    { text: '', style: 'tableHeader', alignment: 'center' },
                    { text: '', style: 'tableHeader', alignment: 'center' },
                  ],
                  [
                    {
                      type: 'none', ol: list_position_num, style: 'table1', alignment: 'center'
                    },
                    {
                      type: 'none', ol: list_person_name, style: 'table1', alignment: 'left'
                    },
                    {
                      type: 'none', ol: list_position_name, style: 'table1', alignment: 'center'
                    },
                    { text: '', style: 'tableHeader', alignment: 'center' },
                    {
                      type: 'none', ol: list_salary_value, style: 'table1', alignment: 'right'
                    },
                    { text: '', style: 'tableHeader', alignment: 'center' },
                    { text: '', style: 'tableHeader', alignment: 'center' },
                    {
                      type: 'none', ol: list_salary_total, style: 'table1', alignment: 'right'
                    },
                    {
                      type: 'none', ol: list_etc, style: 'table1', alignment: 'left'
                    },
                  ],
                  [
                    {
                      text: 'รวมทั้งสิ้น', style: 'tableHeader', alignment: 'center', colSpan: 4
                    }, {}, {}, {},
                    { text: currencyFormat(sum_salary_value), style: 'tableHeader', alignment: 'center' },
                    { text: '', style: 'tableHeader', alignment: 'center' },
                    { text: '', style: 'tableHeader', alignment: 'center' },
                    { text: currencyFormat(sum_total_salary), style: 'tableHeader', alignment: 'center' },
                    { text: '', style: 'tableHeader', alignment: 'center' },
                  ],
                  [
                    {
                      text: dka_detail, style: 'table1', alignment: 'left', colSpan: 5
                    }, {}, {}, {}, {},
                    { text: 'รวมเบิกเดือนนี้\nหักภาษี ณ ที่จ่าย\nคงเหลือ', style: 'tableHeader', alignment: 'left', colSpan: 2 },
                    {},
                    { text: currencyFormat(sum_total_salary) + '\n' + currencyFormat(tax_value) + '\n' + currencyFormat(sum_total_salary - tax_value), style: 'tableHeader', alignment: 'right' },
                    { text: '', style: 'tableHeader', alignment: 'center' },
                  ]
                ]
              }
            }
          ]
        }, {
          columns: [
            { width: 550, text: [{ text: '\n\n', style: 'table1', alignment: 'left' }] },
          ]
        }, {
          columns: [
            { width: 580, text: [{ text: '', style: 'table1', alignment: 'left' }] },
            { width: 250, text: [{ text: 'ลงชื่อ................................................ผู้เบิก\n(' + Finder_name + ")\n" + Finder_position, style: 'tableHeader2', alignment: 'center' }] }
          ]
        }
      ],
      defaultStyle: {
        font: 'THSarabunNew',
        fontSize: 14,
        columnGap: 10,
        lineHeight: 1.2
      },
      styles: {
        header: {
          fontSize: 16,
          bold: true,
        },
        header2: {
          fontSize: 26,
          bold: true
        },
        header3: {
          fontSize: 22,
          bold: true,
          decoration: 'underline',
        },
        tableExample: {
          margin: [0, 0, 0, 15]
        },
        tableHeader: {
          fontSize: 12,
          bold: true,
        },
        tableHeader2: {
          fontSize: 12,
          bold: true,
        },
        tableHeader3: {
          fontSize: 12,
          bold: true,
          decoration: 'underline',
        },
        table1: {
          fontSize: 12,
        },
        table2: {
          fontSize: 12,
        },
        subheader: {
          fontSize: 16,
        },
        quote: {
          italics: true
        },
        small: {
          fontSize: 10
        },
        awesome: {
          font: 'FontAwesome',
          fontSize: 14,
        }
      }
    };
    return docDefinition;
  }
  const report_4109_2 = async (reportTypeId) => {
    let list_person_name = [];
    let list_position_num = [];
    let list_position_name = [];
    let list_salary_value = [];
    let list_salary_total = [];
    let list_etc = [];
    let salary_value = [];
    let salary_total = [];

    const { dka_id, dka_years, dka_detail, tax_value, Finder_name, Finder_position } = await loadEslipReportConfig(reportTypeId);
    newSlipData.forEach(slip => {
      if (slip[90] !== undefined) {
        list_person_name.push(slip.fullname);
        list_position_num.push(slip.position_num);
        list_position_name.push(slip.position_name);

        if (slip.etc === undefined || slip.etc === null) {
          list_etc.push("\n");
        }
        else {
          list_etc.push(slip.etc);
        }
        if (slip[90] === undefined) {
          list_salary_value.push("-");
          list_salary_total.push("-");
        }
        else {
          list_salary_value.push(slip[90]);
          list_salary_total.push(slip[90]);
          salary_value.push(parseFloat(slip[90].replace(',', '')));
          salary_total.push(parseFloat(slip[90].replace(',', '')));
        }
      }
    })
    const sum_salary_value = salary_value.reduce((a, b) => a + b, 0)
    const sum_total_salary = salary_total.reduce((a, b) => a + b, 0)

    let docDefinition = {
      pageSize: 'A4',
      pageOrientation: 'landscape',
      pageMargins: [20, 20, 20, 20],
      content: [
        {
          absolutePosition: { x: 600, y: 30 },
          columns: [
            {
              width: 150,
              text: [
                { text: 'ฎีกาที่ ', style: 'header2', alignment: 'left' },
                { text: dka_id + '/' + dka_years, style: 'header3', alignment: 'left' }
              ]
            }
          ]
        },
        {
          columns: [
            {
              width: 440,
              text: []
            },
            {
              width: 140,
              text: [
                { text: '\uf096  ', style: 'awesome', alignment: 'left' }, //{ text: '\uf046 ', style: 'awesome', alignment: 'right' },               
                { text: 'ประจำ', style: 'subheader', alignment: 'left' }
              ]
            },
            {
              width: 130,
              text: [
              ]
            },
            {
              width: 70,
              text: [
                { text: 'แบบ 4109', style: 'header', alignment: 'left' }
              ]
            }
          ]
        },
        {
          columns: [
            { width: 50, text: [] },
            { width: 120, text: [{ text: 'แบบแนบฎีกา', style: 'subheader', alignment: 'left' }] },
            { width: 120, text: [{ text: '\uf096  ', style: 'awesome', alignment: 'left' }, { text: 'เงินเดือน', style: 'subheader', alignment: 'left' }] },
            { width: 120, text: [{ text: '\uf096  ', style: 'awesome', alignment: 'left' }, { text: 'ค่าจ้าง', style: 'subheader', alignment: 'left' }] },
            { width: 140, text: [{ text: '\uf096  ', style: 'awesome', alignment: 'left' }, { text: 'ชั่วคราวรายเดือน', style: 'subheader', alignment: 'left' }] },
            { width: 130, text: [] },
            { width: 70, text: [] }
          ]
        },
        {
          columns: [
            { width: 440, text: [] },
            { width: 140, text: [{ text: '\uf096  ', style: 'awesome', alignment: 'left' }, { text: 'ชั่วคราวรายวัน', style: 'subheader', alignment: 'left' }] },
            { width: 55, text: [] },
            { width: 145, text: [{ text: '\uf096  ', style: 'awesome', alignment: 'left' }, { text: 'เบี้ยหวัดบำนาญ', style: 'subheader', alignment: 'left' }] }
          ]
        }, {
          columns: [
            { width: 100, text: [] },
            { width: 55, text: [{ text: 'ส่วนราชการ', style: 'subheader', alignment: 'left' }] },
            { width: 130, text: [{ text: 'มหาวิทยาลัยราชภักสกลนคร', style: 'header', alignment: 'left' }] },
            { width: 30, text: [{ text: 'จังหวัด', style: 'subheader', alignment: 'left' }] },
            { width: 50, text: [{ text: 'สกลนคร', style: 'header', alignment: 'left' }] },
            { width: 45, text: [] },
            { width: 80, text: [{ text: 'ประจำเดือน', style: 'subheader', alignment: 'left' }] },
            { width: 80, text: [{ text: moment(budgetYears).format('MMMM'), style: 'header', alignment: 'left' }] },
            { width: 20, text: [{ text: 'พ.ศ.', style: 'subheader', alignment: 'left' }] },
            { width: 225, text: [{ text: parseInt(moment(budgetYears).format('YYYY')) + 543, style: 'header', alignment: 'left' }] }
          ]
        },
        {
          columns: [
            {
              table: {
                widths: [45, 155, 150, 42, 60, 30, 50, 60, 120],
                headerRows: 1,
                body: [
                  [
                    { text: 'เลขประจำ\nตำแหน่ง', style: 'tableHeader', alignment: 'center' },
                    { text: 'ชื่อ - สกุล/จำนวนอัตรา', style: 'tableHeader', alignment: 'center' },
                    { text: 'ตำแหน่ง', style: 'tableHeader', alignment: 'center' },
                    { text: 'ระดับ / \nขั้น', style: 'tableHeader', alignment: 'center' },
                    { text: 'ขั้น', style: 'tableHeader', alignment: 'center' },
                    { text: 'เบิกลด', style: 'tableHeader', alignment: 'center' },
                    { text: 'เงินเพิ่ม', style: 'tableHeader', alignment: 'center' },
                    { text: 'รวมเบิก', style: 'tableHeader', alignment: 'center' },
                    { text: 'หมายเหตุ', style: 'tableHeader', alignment: 'center' }
                  ],
                  [
                    { text: '', style: 'tableHeader', alignment: 'center' },
                    {
                      text: 'เงินประจำตำแหน่งทางวิชาการพนักงานมหาวิทยาลัย', style: 'tableHeader3', alignment: 'center', colSpan: 2
                    }, {}, {},
                    { text: '', style: 'tableHeader', alignment: 'center' },
                    { text: '', style: 'tableHeader', alignment: 'center' },
                    { text: '', style: 'tableHeader', alignment: 'center' },
                    { text: '', style: 'tableHeader', alignment: 'center' },
                    { text: '', style: 'tableHeader', alignment: 'center' },
                  ],
                  [
                    {
                      type: 'none', ol: list_position_num, style: 'table1', alignment: 'center'
                    },
                    {
                      type: 'none', ol: list_person_name, style: 'table1', alignment: 'left'
                    },
                    {
                      type: 'none', ol: list_position_name, style: 'table1', alignment: 'center'
                    },
                    { text: '', style: 'tableHeader', alignment: 'center' },
                    {
                      type: 'none', ol: list_salary_value, style: 'table1', alignment: 'right'
                    },
                    { text: '', style: 'tableHeader', alignment: 'center' },
                    { text: '', style: 'tableHeader', alignment: 'center' },
                    {
                      type: 'none', ol: list_salary_total, style: 'table1', alignment: 'right'
                    },
                    {
                      type: 'none', ol: list_etc, style: 'table1', alignment: 'left'
                    },
                  ],
                  [
                    {
                      text: 'รวมทั้งสิ้น', style: 'tableHeader', alignment: 'center', colSpan: 4
                    }, {}, {}, {},
                    { text: currencyFormat(sum_salary_value), style: 'tableHeader', alignment: 'center' },
                    { text: '', style: 'tableHeader', alignment: 'center' },
                    { text: '', style: 'tableHeader', alignment: 'center' },
                    { text: currencyFormat(sum_total_salary), style: 'tableHeader', alignment: 'center' },
                    { text: '', style: 'tableHeader', alignment: 'center' },
                  ],
                  [
                    {
                      text: dka_detail, style: 'table1', alignment: 'left', colSpan: 5
                    }, {}, {}, {}, {},
                    { text: 'รวมเบิกเดือนนี้\nหักภาษี ณ ที่จ่าย\nคงเหลือ', style: 'tableHeader', alignment: 'left', colSpan: 2 },
                    {},
                    { text: currencyFormat(sum_total_salary) + '\n' + currencyFormat(tax_value) + '\n' + currencyFormat(sum_total_salary - tax_value), style: 'tableHeader', alignment: 'right' },
                    { text: '', style: 'tableHeader', alignment: 'center' },
                  ]
                ]
              }
            }
          ]
        }, {
          columns: [
            { width: 550, text: [{ text: '\n\n', style: 'table1', alignment: 'left' }] },
          ]
        }, {
          columns: [
            { width: 580, text: [{ text: '', style: 'table1', alignment: 'left' }] },
            { width: 250, text: [{ text: 'ลงชื่อ................................................ผู้เบิก\n(' + Finder_name + ")\n" + Finder_position, style: 'tableHeader2', alignment: 'center' }] }
          ]
        }
      ],
      defaultStyle: {
        font: 'THSarabunNew',
        fontSize: 14,
        columnGap: 10,
        lineHeight: 1.2
      },
      styles: {
        header: {
          fontSize: 16,
          bold: true,
        },
        header2: {
          fontSize: 26,
          bold: true
        },
        header3: {
          fontSize: 22,
          bold: true,
          decoration: 'underline',
        },
        tableExample: {
          margin: [0, 0, 0, 15]
        },
        tableHeader: {
          fontSize: 12,
          bold: true,
        },
        tableHeader2: {
          fontSize: 12,
          bold: true,
        },
        tableHeader3: {
          fontSize: 12,
          bold: true,
          decoration: 'underline',
        },
        table1: {
          fontSize: 12,
        },
        table2: {
          fontSize: 12,
        },
        subheader: {
          fontSize: 16,
        },
        quote: {
          italics: true
        },
        small: {
          fontSize: 10
        },
        awesome: {
          font: 'FontAwesome',
          fontSize: 14,
        }
      }
    };
    return docDefinition;
  }
  const report_4109_3 = async (reportTypeId) => {
    let list_person_name = [];
    let list_position_num = [];
    let list_position_name = [];
    let list_salary_value = [];
    let list_salary_total = [];
    let list_etc = [];
    let salary_value = [];
    let salary_total = [];

    const { dka_id, dka_years, dka_detail, tax_value, Finder_name, Finder_position } = await loadEslipReportConfig(reportTypeId);
    newSlipData.forEach(slip => {
      if (slip[4] !== undefined) {
        list_person_name.push(slip.fullname);
        list_position_num.push(slip.position_num);
        list_position_name.push(slip.position_name);

        if (slip.etc === undefined || slip.etc === null) {
          list_etc.push("\n");
        }
        else {
          list_etc.push(slip.etc);
        }
        if (slip[4] === undefined) {
          list_salary_value.push("-");
          list_salary_total.push("-");
        }
        else {
          list_salary_value.push(slip[4]);
          list_salary_total.push(slip[4]);
          salary_value.push(parseFloat(slip[4].replace(',', '')));
          salary_total.push(parseFloat(slip[4].replace(',', '')));
        }
      }
    })
    const sum_salary_value = salary_value.reduce((a, b) => a + b, 0)
    const sum_total_salary = salary_total.reduce((a, b) => a + b, 0)

    let docDefinition = {
      pageSize: 'A4',
      pageOrientation: 'landscape',
      pageMargins: [20, 20, 20, 20],
      content: [
        {
          absolutePosition: { x: 600, y: 30 },
          columns: [
            {
              width: 150,
              text: [
                { text: 'ฎีกาที่ ', style: 'header2', alignment: 'left' },
                { text: dka_id + '/' + dka_years, style: 'header3', alignment: 'left' }
              ]
            }
          ]
        },
        {
          columns: [
            {
              width: 440,
              text: []
            },
            {
              width: 140,
              text: [
                { text: '\uf096  ', style: 'awesome', alignment: 'left' }, //{ text: '\uf046 ', style: 'awesome', alignment: 'right' },               
                { text: 'ประจำ', style: 'subheader', alignment: 'left' }
              ]
            },
            {
              width: 130,
              text: [
              ]
            },
            {
              width: 70,
              text: [
                { text: 'แบบ 4109', style: 'header', alignment: 'left' }
              ]
            }
          ]
        },
        {
          columns: [
            { width: 50, text: [] },
            { width: 120, text: [{ text: 'แบบแนบฎีกา', style: 'subheader', alignment: 'left' }] },
            { width: 120, text: [{ text: '\uf096  ', style: 'awesome', alignment: 'left' }, { text: 'เงินเดือน', style: 'subheader', alignment: 'left' }] },
            { width: 120, text: [{ text: '\uf096  ', style: 'awesome', alignment: 'left' }, { text: 'ค่าจ้าง', style: 'subheader', alignment: 'left' }] },
            { width: 140, text: [{ text: '\uf096  ', style: 'awesome', alignment: 'left' }, { text: 'ชั่วคราวรายเดือน', style: 'subheader', alignment: 'left' }] },
            { width: 130, text: [] },
            { width: 70, text: [] }
          ]
        },
        {
          columns: [
            { width: 440, text: [] },
            { width: 140, text: [{ text: '\uf096  ', style: 'awesome', alignment: 'left' }, { text: 'ชั่วคราวรายวัน', style: 'subheader', alignment: 'left' }] },
            { width: 55, text: [] },
            { width: 145, text: [{ text: '\uf096  ', style: 'awesome', alignment: 'left' }, { text: 'เบี้ยหวัดบำนาญ', style: 'subheader', alignment: 'left' }] }
          ]
        }, {
          columns: [
            { width: 100, text: [] },
            { width: 55, text: [{ text: 'ส่วนราชการ', style: 'subheader', alignment: 'left' }] },
            { width: 130, text: [{ text: 'มหาวิทยาลัยราชภักสกลนคร', style: 'header', alignment: 'left' }] },
            { width: 30, text: [{ text: 'จังหวัด', style: 'subheader', alignment: 'left' }] },
            { width: 50, text: [{ text: 'สกลนคร', style: 'header', alignment: 'left' }] },
            { width: 45, text: [] },
            { width: 80, text: [{ text: 'ประจำเดือน', style: 'subheader', alignment: 'left' }] },
            { width: 80, text: [{ text: moment(budgetYears).format('MMMM'), style: 'header', alignment: 'left' }] },
            { width: 20, text: [{ text: 'พ.ศ.', style: 'subheader', alignment: 'left' }] },
            { width: 225, text: [{ text: parseInt(moment(budgetYears).format('YYYY')) + 543, style: 'header', alignment: 'left' }] }
          ]
        },
        {
          columns: [
            {
              table: {
                widths: [45, 155, 150, 42, 60, 30, 50, 60, 120],
                headerRows: 1,
                body: [
                  [
                    { text: 'เลขประจำ\nตำแหน่ง', style: 'tableHeader', alignment: 'center' },
                    { text: 'ชื่อ - สกุล/จำนวนอัตรา', style: 'tableHeader', alignment: 'center' },
                    { text: 'ตำแหน่ง', style: 'tableHeader', alignment: 'center' },
                    { text: 'ระดับ / \nขั้น', style: 'tableHeader', alignment: 'center' },
                    { text: 'ขั้น', style: 'tableHeader', alignment: 'center' },
                    { text: 'เบิกลด', style: 'tableHeader', alignment: 'center' },
                    { text: 'เงินเพิ่ม', style: 'tableHeader', alignment: 'center' },
                    { text: 'รวมเบิก', style: 'tableHeader', alignment: 'center' },
                    { text: 'หมายเหตุ', style: 'tableHeader', alignment: 'center' }
                  ],
                  [
                    { text: '', style: 'tableHeader', alignment: 'center' },
                    {
                      text: 'เงินประจำตำแหน่งผู้บริหารมีวาระและเงินเทียบเท่าพนักงานมหาวิทยาลัย', style: 'tableHeader3', alignment: 'center', colSpan: 2
                    }, {}, {},
                    { text: '', style: 'tableHeader', alignment: 'center' },
                    { text: '', style: 'tableHeader', alignment: 'center' },
                    { text: '', style: 'tableHeader', alignment: 'center' },
                    { text: '', style: 'tableHeader', alignment: 'center' },
                    { text: '', style: 'tableHeader', alignment: 'center' },
                  ],
                  [
                    {
                      type: 'none', ol: list_position_num, style: 'table1', alignment: 'center'
                    },
                    {
                      type: 'none', ol: list_person_name, style: 'table1', alignment: 'left'
                    },
                    {
                      type: 'none', ol: list_position_name, style: 'table1', alignment: 'center'
                    },
                    { text: '', style: 'tableHeader', alignment: 'center' },
                    {
                      type: 'none', ol: list_salary_value, style: 'table1', alignment: 'right'
                    },
                    { text: '', style: 'tableHeader', alignment: 'center' },
                    { text: '', style: 'tableHeader', alignment: 'center' },
                    {
                      type: 'none', ol: list_salary_total, style: 'table1', alignment: 'right'
                    },
                    {
                      type: 'none', ol: list_etc, style: 'table1', alignment: 'left'
                    },
                  ],
                  [
                    {
                      text: 'รวมทั้งสิ้น', style: 'tableHeader', alignment: 'center', colSpan: 4
                    }, {}, {}, {},
                    { text: currencyFormat(sum_salary_value), style: 'tableHeader', alignment: 'center' },
                    { text: '', style: 'tableHeader', alignment: 'center' },
                    { text: '', style: 'tableHeader', alignment: 'center' },
                    { text: currencyFormat(sum_total_salary), style: 'tableHeader', alignment: 'center' },
                    { text: '', style: 'tableHeader', alignment: 'center' },
                  ],
                  [
                    {
                      text: dka_detail, style: 'table1', alignment: 'left', colSpan: 5
                    }, {}, {}, {}, {},
                    { text: 'รวมเบิกเดือนนี้\nหักภาษี ณ ที่จ่าย\nคงเหลือ', style: 'tableHeader', alignment: 'left', colSpan: 2 },
                    {},
                    { text: currencyFormat(sum_total_salary) + '\n' + currencyFormat(tax_value) + '\n' + currencyFormat(sum_total_salary - tax_value), style: 'tableHeader', alignment: 'right' },
                    { text: '', style: 'tableHeader', alignment: 'center' },
                  ]
                ]
              }
            }
          ]
        }, {
          columns: [
            { width: 550, text: [{ text: '\n\n', style: 'table1', alignment: 'left' }] },
          ]
        }, {
          columns: [
            { width: 580, text: [{ text: '', style: 'table1', alignment: 'left' }] },
            { width: 250, text: [{ text: 'ลงชื่อ................................................ผู้เบิก\n(' + Finder_name + ")\n" + Finder_position, style: 'tableHeader2', alignment: 'center' }] }
          ]
        }
      ],
      defaultStyle: {
        font: 'THSarabunNew',
        fontSize: 14,
        columnGap: 10,
        lineHeight: 1.2
      },
      styles: {
        header: {
          fontSize: 16,
          bold: true,
        },
        header2: {
          fontSize: 26,
          bold: true
        },
        header3: {
          fontSize: 22,
          bold: true,
          decoration: 'underline',
        },
        tableExample: {
          margin: [0, 0, 0, 15]
        },
        tableHeader: {
          fontSize: 12,
          bold: true,
        },
        tableHeader2: {
          fontSize: 12,
          bold: true,
        },
        tableHeader3: {
          fontSize: 12,
          bold: true,
          decoration: 'underline',
        },
        table1: {
          fontSize: 12,
        },
        table2: {
          fontSize: 12,
        },
        subheader: {
          fontSize: 16,
        },
        quote: {
          italics: true
        },
        small: {
          fontSize: 10
        },
        awesome: {
          font: 'FontAwesome',
          fontSize: 14,
        }
      }
    };
    return docDefinition;
  }
  const report_4109_31 = async (reportTypeId) => {
    let list_person_name = [];
    let list_position_num = [];
    let list_position_name = [];
    let list_salary_value = [];
    let list_salary_total = [];
    let list_etc = [];
    let salary_value = [];
    let salary_total = [];

    const { dka_id, dka_years, dka_detail, tax_value, Finder_name, Finder_position } = await loadEslipReportConfig(reportTypeId);
    newSlipData.forEach(slip => {
      if (slip[5] !== undefined) {
        list_person_name.push(slip.fullname);
        list_position_num.push(slip.position_num);
        list_position_name.push(slip.position_name);

        if (slip.etc === undefined || slip.etc === null) {
          list_etc.push("\n");
        }
        else {
          list_etc.push(slip.etc);
        }
        if (slip[4] === undefined) {
          list_salary_value.push("-");
          list_salary_total.push("-");
        }
        else {
          list_salary_value.push(slip[5]);
          list_salary_total.push(slip[5]);
          salary_value.push(parseFloat(slip[5].replace(',', '')));
          salary_total.push(parseFloat(slip[5].replace(',', '')));
        }
      }
    })
    const sum_salary_value = salary_value.reduce((a, b) => a + b, 0)
    const sum_total_salary = salary_total.reduce((a, b) => a + b, 0)

    let docDefinition = {
      pageSize: 'A4',
      pageOrientation: 'landscape',
      pageMargins: [20, 20, 20, 20],
      content: [
        {
          absolutePosition: { x: 600, y: 30 },
          columns: [
            {
              width: 150,
              text: [
                { text: 'ฎีกาที่ ', style: 'header2', alignment: 'left' },
                { text: dka_id + '/' + dka_years, style: 'header3', alignment: 'left' }
              ]
            }
          ]
        },
        {
          columns: [
            {
              width: 440,
              text: []
            },
            {
              width: 140,
              text: [
                { text: '\uf096  ', style: 'awesome', alignment: 'left' }, //{ text: '\uf046 ', style: 'awesome', alignment: 'right' },               
                { text: 'ประจำ', style: 'subheader', alignment: 'left' }
              ]
            },
            {
              width: 130,
              text: [
              ]
            },
            {
              width: 70,
              text: [
                { text: 'แบบ 4109', style: 'header', alignment: 'left' }
              ]
            }
          ]
        },
        {
          columns: [
            { width: 50, text: [] },
            { width: 120, text: [{ text: 'แบบแนบฎีกา', style: 'subheader', alignment: 'left' }] },
            { width: 120, text: [{ text: '\uf096  ', style: 'awesome', alignment: 'left' }, { text: 'เงินเดือน', style: 'subheader', alignment: 'left' }] },
            { width: 120, text: [{ text: '\uf096  ', style: 'awesome', alignment: 'left' }, { text: 'ค่าจ้าง', style: 'subheader', alignment: 'left' }] },
            { width: 140, text: [{ text: '\uf096  ', style: 'awesome', alignment: 'left' }, { text: 'ชั่วคราวรายเดือน', style: 'subheader', alignment: 'left' }] },
            { width: 130, text: [] },
            { width: 70, text: [] }
          ]
        },
        {
          columns: [
            { width: 440, text: [] },
            { width: 140, text: [{ text: '\uf096  ', style: 'awesome', alignment: 'left' }, { text: 'ชั่วคราวรายวัน', style: 'subheader', alignment: 'left' }] },
            { width: 55, text: [] },
            { width: 145, text: [{ text: '\uf096  ', style: 'awesome', alignment: 'left' }, { text: 'เบี้ยหวัดบำนาญ', style: 'subheader', alignment: 'left' }] }
          ]
        }, {
          columns: [
            { width: 100, text: [] },
            { width: 55, text: [{ text: 'ส่วนราชการ', style: 'subheader', alignment: 'left' }] },
            { width: 130, text: [{ text: 'มหาวิทยาลัยราชภักสกลนคร', style: 'header', alignment: 'left' }] },
            { width: 30, text: [{ text: 'จังหวัด', style: 'subheader', alignment: 'left' }] },
            { width: 50, text: [{ text: 'สกลนคร', style: 'header', alignment: 'left' }] },
            { width: 45, text: [] },
            { width: 80, text: [{ text: 'ประจำเดือน', style: 'subheader', alignment: 'left' }] },
            { width: 80, text: [{ text: moment(budgetYears).format('MMMM'), style: 'header', alignment: 'left' }] },
            { width: 20, text: [{ text: 'พ.ศ.', style: 'subheader', alignment: 'left' }] },
            { width: 225, text: [{ text: parseInt(moment(budgetYears).format('YYYY')) + 543, style: 'header', alignment: 'left' }] }
          ]
        },
        {
          columns: [
            {
              table: {
                widths: [45, 155, 150, 42, 60, 30, 50, 60, 120],
                headerRows: 1,
                body: [
                  [
                    { text: 'เลขประจำ\nตำแหน่ง', style: 'tableHeader', alignment: 'center' },
                    { text: 'ชื่อ - สกุล/จำนวนอัตรา', style: 'tableHeader', alignment: 'center' },
                    { text: 'ตำแหน่ง', style: 'tableHeader', alignment: 'center' },
                    { text: 'ระดับ / \nขั้น', style: 'tableHeader', alignment: 'center' },
                    { text: 'ขั้น', style: 'tableHeader', alignment: 'center' },
                    { text: 'เบิกลด', style: 'tableHeader', alignment: 'center' },
                    { text: 'เงินเพิ่ม', style: 'tableHeader', alignment: 'center' },
                    { text: 'รวมเบิก', style: 'tableHeader', alignment: 'center' },
                    { text: 'หมายเหตุ', style: 'tableHeader', alignment: 'center' }
                  ],
                  [
                    { text: '', style: 'tableHeader', alignment: 'center' },
                    {
                      text: 'เงินประจำตำแหน่งตกเบิกผู้บริหารพนักงานมหาวิทยาลัย', style: 'tableHeader3', alignment: 'center', colSpan: 2
                    }, {}, {},
                    { text: '', style: 'tableHeader', alignment: 'center' },
                    { text: '', style: 'tableHeader', alignment: 'center' },
                    { text: '', style: 'tableHeader', alignment: 'center' },
                    { text: '', style: 'tableHeader', alignment: 'center' },
                    { text: '', style: 'tableHeader', alignment: 'center' },
                  ],
                  [
                    {
                      type: 'none', ol: list_position_num, style: 'table1', alignment: 'center'
                    },
                    {
                      type: 'none', ol: list_person_name, style: 'table1', alignment: 'left'
                    },
                    {
                      type: 'none', ol: list_position_name, style: 'table1', alignment: 'center'
                    },
                    { text: '', style: 'tableHeader', alignment: 'center' },
                    {
                      type: 'none', ol: list_salary_value, style: 'table1', alignment: 'right'
                    },
                    { text: '', style: 'tableHeader', alignment: 'center' },
                    { text: '', style: 'tableHeader', alignment: 'center' },
                    {
                      type: 'none', ol: list_salary_total, style: 'table1', alignment: 'right'
                    },
                    {
                      type: 'none', ol: list_etc, style: 'table1', alignment: 'left'
                    },
                  ],
                  [
                    {
                      text: 'รวมทั้งสิ้น', style: 'tableHeader', alignment: 'center', colSpan: 4
                    }, {}, {}, {},
                    { text: currencyFormat(sum_salary_value), style: 'tableHeader', alignment: 'center' },
                    { text: '', style: 'tableHeader', alignment: 'center' },
                    { text: '', style: 'tableHeader', alignment: 'center' },
                    { text: currencyFormat(sum_total_salary), style: 'tableHeader', alignment: 'center' },
                    { text: '', style: 'tableHeader', alignment: 'center' },
                  ],
                  [
                    {
                      text: dka_detail, style: 'table1', alignment: 'left', colSpan: 5
                    }, {}, {}, {}, {},
                    { text: 'รวมเบิกเดือนนี้\nหักภาษี ณ ที่จ่าย\nคงเหลือ', style: 'tableHeader', alignment: 'left', colSpan: 2 },
                    {},
                    { text: currencyFormat(sum_total_salary) + '\n' + currencyFormat(tax_value) + '\n' + currencyFormat(sum_total_salary - tax_value), style: 'tableHeader', alignment: 'right' },
                    { text: '', style: 'tableHeader', alignment: 'center' },
                  ]
                ]
              }
            }
          ]
        }, {
          columns: [
            { width: 550, text: [{ text: '\n\n', style: 'table1', alignment: 'left' }] },
          ]
        }, {
          columns: [
            { width: 580, text: [{ text: '', style: 'table1', alignment: 'left' }] },
            { width: 250, text: [{ text: 'ลงชื่อ................................................ผู้เบิก\n(' + Finder_name + ")\n" + Finder_position, style: 'tableHeader2', alignment: 'center' }] }
          ]
        }
      ],
      defaultStyle: {
        font: 'THSarabunNew',
        fontSize: 14,
        columnGap: 10,
        lineHeight: 1.2
      },
      styles: {
        header: {
          fontSize: 16,
          bold: true,
        },
        header2: {
          fontSize: 26,
          bold: true
        },
        header3: {
          fontSize: 22,
          bold: true,
          decoration: 'underline',
        },
        tableExample: {
          margin: [0, 0, 0, 15]
        },
        tableHeader: {
          fontSize: 12,
          bold: true,
        },
        tableHeader2: {
          fontSize: 12,
          bold: true,
        },
        tableHeader3: {
          fontSize: 12,
          bold: true,
          decoration: 'underline',
        },
        table1: {
          fontSize: 12,
        },
        table2: {
          fontSize: 12,
        },
        subheader: {
          fontSize: 16,
        },
        quote: {
          italics: true
        },
        small: {
          fontSize: 10
        },
        awesome: {
          font: 'FontAwesome',
          fontSize: 14,
        }
      }
    };
    return docDefinition;
  }
  const report_4109_5 = async (reportTypeId) => {
    let list_person_name = [];
    let list_position_num = [];
    let list_position_name = [];
    let list_salary_value = [];
    let list_salary_total = [];
    let list_etc = [];
    let salary_value = [];
    let salary_total = [];

    const { dka_id, dka_years, dka_detail, tax_value, Finder_name, Finder_position } = await loadEslipReportConfig(reportTypeId);
    newSlipData.forEach(slip => {
      if (slip[9] !== undefined) {
        list_person_name.push(slip.fullname);
        list_position_num.push(slip.position_num);
        list_position_name.push(slip.position_name);

        if (slip.etc === undefined || slip.etc === null) {
          list_etc.push("\n");
        }
        else {
          list_etc.push(slip.etc);
        }
        if (slip[9] === undefined) {
          list_salary_value.push("-");
          list_salary_total.push("-");
        }
        else {
          list_salary_value.push(slip[9]);
          list_salary_total.push(slip[9]);
          salary_value.push(parseFloat(slip[9].replace(',', '')));
          salary_total.push(parseFloat(slip[9].replace(',', '')));
        }
      }
    })
    const sum_salary_value = salary_value.reduce((a, b) => a + b, 0)
    const sum_total_salary = salary_total.reduce((a, b) => a + b, 0)

    let docDefinition = {
      pageSize: 'A4',
      pageOrientation: 'landscape',
      pageMargins: [20, 20, 20, 20],
      content: [
        {
          absolutePosition: { x: 600, y: 30 },
          columns: [
            {
              width: 150,
              text: [
                { text: 'ฎีกาที่ ', style: 'header2', alignment: 'left' },
                { text: dka_id + '/' + dka_years, style: 'header3', alignment: 'left' }
              ]
            }
          ]
        },
        {
          columns: [
            {
              width: 440,
              text: []
            },
            {
              width: 140,
              text: [
                { text: '\uf096  ', style: 'awesome', alignment: 'left' }, //{ text: '\uf046 ', style: 'awesome', alignment: 'right' },               
                { text: 'ประจำ', style: 'subheader', alignment: 'left' }
              ]
            },
            {
              width: 130,
              text: [
              ]
            },
            {
              width: 70,
              text: [
                { text: 'แบบ 4109', style: 'header', alignment: 'left' }
              ]
            }
          ]
        },
        {
          columns: [
            { width: 50, text: [] },
            { width: 120, text: [{ text: 'แบบแนบฎีกา', style: 'subheader', alignment: 'left' }] },
            { width: 120, text: [{ text: '\uf096  ', style: 'awesome', alignment: 'left' }, { text: 'เงินเดือน', style: 'subheader', alignment: 'left' }] },
            { width: 120, text: [{ text: '\uf096  ', style: 'awesome', alignment: 'left' }, { text: 'ค่าจ้าง', style: 'subheader', alignment: 'left' }] },
            { width: 140, text: [{ text: '\uf096  ', style: 'awesome', alignment: 'left' }, { text: 'ชั่วคราวรายเดือน', style: 'subheader', alignment: 'left' }] },
            { width: 130, text: [] },
            { width: 70, text: [] }
          ]
        },
        {
          columns: [
            { width: 440, text: [] },
            { width: 140, text: [{ text: '\uf096  ', style: 'awesome', alignment: 'left' }, { text: 'ชั่วคราวรายวัน', style: 'subheader', alignment: 'left' }] },
            { width: 55, text: [] },
            { width: 145, text: [{ text: '\uf096  ', style: 'awesome', alignment: 'left' }, { text: 'เบี้ยหวัดบำนาญ', style: 'subheader', alignment: 'left' }] }
          ]
        }, {
          columns: [
            { width: 100, text: [] },
            { width: 55, text: [{ text: 'ส่วนราชการ', style: 'subheader', alignment: 'left' }] },
            { width: 130, text: [{ text: 'มหาวิทยาลัยราชภักสกลนคร', style: 'header', alignment: 'left' }] },
            { width: 30, text: [{ text: 'จังหวัด', style: 'subheader', alignment: 'left' }] },
            { width: 50, text: [{ text: 'สกลนคร', style: 'header', alignment: 'left' }] },
            { width: 45, text: [] },
            { width: 80, text: [{ text: 'ประจำเดือน', style: 'subheader', alignment: 'left' }] },
            { width: 80, text: [{ text: moment(budgetYears).format('MMMM'), style: 'header', alignment: 'left' }] },
            { width: 20, text: [{ text: 'พ.ศ.', style: 'subheader', alignment: 'left' }] },
            { width: 225, text: [{ text: parseInt(moment(budgetYears).format('YYYY')) + 543, style: 'header', alignment: 'left' }] }
          ]
        },
        {
          columns: [
            {
              table: {
                widths: [45, 155, 150, 42, 60, 30, 50, 60, 120],
                headerRows: 1,
                body: [
                  [
                    { text: 'เลขประจำ\nตำแหน่ง', style: 'tableHeader', alignment: 'center' },
                    { text: 'ชื่อ - สกุล/จำนวนอัตรา', style: 'tableHeader', alignment: 'center' },
                    { text: 'ตำแหน่ง', style: 'tableHeader', alignment: 'center' },
                    { text: 'ระดับ / \nขั้น', style: 'tableHeader', alignment: 'center' },
                    { text: 'ขั้น', style: 'tableHeader', alignment: 'center' },
                    { text: 'เบิกลด', style: 'tableHeader', alignment: 'center' },
                    { text: 'เงินเพิ่ม', style: 'tableHeader', alignment: 'center' },
                    { text: 'รวมเบิก', style: 'tableHeader', alignment: 'center' },
                    { text: 'หมายเหตุ', style: 'tableHeader', alignment: 'center' }
                  ],
                  [
                    { text: '', style: 'tableHeader', alignment: 'center' },
                    {
                      text: 'เงินสมทบกองทุนประกันสังคม - พนักงานมหาวิทยาลัย', style: 'tableHeader3', alignment: 'center', colSpan: 2
                    }, {}, {},
                    { text: '', style: 'tableHeader', alignment: 'center' },
                    { text: '', style: 'tableHeader', alignment: 'center' },
                    { text: '', style: 'tableHeader', alignment: 'center' },
                    { text: '', style: 'tableHeader', alignment: 'center' },
                    { text: '', style: 'tableHeader', alignment: 'center' },
                  ],
                  [
                    {
                      type: 'none', ol: list_position_num, style: 'table1', alignment: 'center'
                    },
                    {
                      type: 'none', ol: list_person_name, style: 'table1', alignment: 'left'
                    },
                    {
                      type: 'none', ol: list_position_name, style: 'table1', alignment: 'center'
                    },
                    { text: '', style: 'tableHeader', alignment: 'center' },
                    {
                      type: 'none', ol: list_salary_value, style: 'table1', alignment: 'right'
                    },
                    { text: '', style: 'tableHeader', alignment: 'center' },
                    { text: '', style: 'tableHeader', alignment: 'center' },
                    {
                      type: 'none', ol: list_salary_total, style: 'table1', alignment: 'right'
                    },
                    {
                      type: 'none', ol: list_etc, style: 'table1', alignment: 'left'
                    },
                  ],
                  [
                    {
                      text: 'รวมทั้งสิ้น', style: 'tableHeader', alignment: 'center', colSpan: 4
                    }, {}, {}, {},
                    { text: currencyFormat(sum_salary_value), style: 'tableHeader', alignment: 'center' },
                    { text: '', style: 'tableHeader', alignment: 'center' },
                    { text: '', style: 'tableHeader', alignment: 'center' },
                    { text: currencyFormat(sum_total_salary), style: 'tableHeader', alignment: 'center' },
                    { text: '', style: 'tableHeader', alignment: 'center' },
                  ],
                  [
                    {
                      text: dka_detail, style: 'table1', alignment: 'left', colSpan: 5
                    }, {}, {}, {}, {},
                    { text: 'รวมเบิกเดือนนี้\nหักภาษี ณ ที่จ่าย\nคงเหลือ', style: 'tableHeader', alignment: 'left', colSpan: 2 },
                    {},
                    { text: currencyFormat(sum_total_salary) + '\n' + currencyFormat(tax_value) + '\n' + currencyFormat(sum_total_salary - tax_value), style: 'tableHeader', alignment: 'right' },
                    { text: '', style: 'tableHeader', alignment: 'center' },
                  ]
                ]
              }
            }
          ]
        }, {
          columns: [
            { width: 550, text: [{ text: '\n\n', style: 'table1', alignment: 'left' }] },
          ]
        }, {
          columns: [
            { width: 580, text: [{ text: '', style: 'table1', alignment: 'left' }] },
            { width: 250, text: [{ text: 'ลงชื่อ................................................ผู้เบิก\n(' + Finder_name + ")\n" + Finder_position, style: 'tableHeader2', alignment: 'center' }] }
          ]
        }
      ],
      defaultStyle: {
        font: 'THSarabunNew',
        fontSize: 14,
        columnGap: 10,
        lineHeight: 1.2
      },
      styles: {
        header: {
          fontSize: 16,
          bold: true,
        },
        header2: {
          fontSize: 26,
          bold: true
        },
        header3: {
          fontSize: 22,
          bold: true,
          decoration: 'underline',
        },
        tableExample: {
          margin: [0, 0, 0, 15]
        },
        tableHeader: {
          fontSize: 12,
          bold: true,
        },
        tableHeader2: {
          fontSize: 12,
          bold: true,
        },
        tableHeader3: {
          fontSize: 12,
          bold: true,
          decoration: 'underline',
        },
        table1: {
          fontSize: 12,
        },
        table2: {
          fontSize: 12,
        },
        subheader: {
          fontSize: 16,
        },
        quote: {
          italics: true
        },
        small: {
          fontSize: 10
        },
        awesome: {
          font: 'FontAwesome',
          fontSize: 14,
        }
      }
    };
    return docDefinition;
  }
  const report_4109_7 = async (reportTypeId) => {
    let reports = await loadEslipReport_7(budgetYears);
    let arr = [[
      { text: 'ลำดับ', style: 'tableHeader', alignment: 'center' },
      { text: 'เลขที่\nตำแหน่ง', style: 'tableHeader', alignment: 'center' },
      { text: 'ชื่อ - สกุล', style: 'tableHeader', alignment: 'center' },
      { text: 'หน่วยงาน / สาขา', style: 'tableHeader', alignment: 'center' },
      { text: 'ตำแหน่ง', style: 'tableHeader', alignment: 'center' },
      { text: 'เงินเดือน', style: 'tableHeader', alignment: 'center' },
      { text: 'เงินเดือน\nตกเบิก', style: 'tableHeader', alignment: 'center' },
      { text: 'ค่าครอง\nชีพ', style: 'tableHeader', alignment: 'center' },
      { text: 'กองทุน\nสะสม', style: 'tableHeader', alignment: 'center' },
      { text: 'กองทุน\nย่อย', style: 'tableHeader', alignment: 'center' },
      { text: 'ประกัน\nสังคม', style: 'tableHeader', alignment: 'center' },
      { text: 'ประกัน\nสังคมย่อย', style: 'tableHeader', alignment: 'center' }
    ]];
    let n = 1;
    let project_name = 'xxxxx';
    let money_1 = 0;
    let money_2 = 0;
    let money_3 = 0;
    let money_7 = 0;
    let money_8 = 0;
    let money_9 = 0;
    let money_10 = 0;

    let total_money_1 = 0;
    let total_money_2 = 0;
    let total_money_3 = 0;
    let total_money_7 = 0;
    let total_money_8 = 0;
    let total_money_9 = 0;
    let total_money_10 = 0;
    reports.forEach(report => {
      if (project_name === report.project_activities_id) {
        arr.push([
          { text: n, style: 'table1', alignment: 'left' },
          { text: report.position_num, style: 'table1', alignment: 'center' },
          { text: report.prefix_name + report.fnamethai + " " + report.lnamethai, style: 'table1', alignment: 'left' },
          { text: report.project_activities_id, style: 'table1', alignment: 'center' },
          { text: report.position_name, style: 'table1', alignment: 'center' },
          { text: currencyFormat((report.money_type_id_1 !== null) ? report.money_type_id_1 : 0), style: 'table1', alignment: 'right' },
          { text: currencyFormat((report.money_type_id_2 !== null) ? report.money_type_id_2 : 0), style: 'table1', alignment: 'right' },
          { text: currencyFormat((report.money_type_id_3 !== null) ? report.money_type_id_3 : 0), style: 'table1', alignment: 'right' },
          { text: currencyFormat((report.money_type_id_7 !== null) ? report.money_type_id_7 : 0), style: 'table1', alignment: 'right' },
          { text: currencyFormat((report.money_type_id_8 !== null) ? report.money_type_id_8 : 0), style: 'table1', alignment: 'right' },
          { text: currencyFormat((report.money_type_id_9 !== null) ? report.money_type_id_9 : 0), style: 'table1', alignment: 'right' },
          { text: currencyFormat((report.money_type_id_10 !== null) ? report.money_type_id_10 : 0), style: 'table1', alignment: 'right' }
        ])

        money_1 = parseFloat(money_1) + parseFloat(((report.money_type_id_1 !== null) ? report.money_type_id_1 : 0));
        money_2 = parseFloat(money_2) + parseFloat(((report.money_type_id_2 !== null) ? report.money_type_id_2 : 0));
        money_3 = parseFloat(money_3) + parseFloat(((report.money_type_id_3 !== null) ? report.money_type_id_3 : 0));
        money_7 = parseFloat(money_7) + parseFloat(((report.money_type_id_7 !== null) ? report.money_type_id_7 : 0));
        money_8 = parseFloat(money_8) + parseFloat(((report.money_type_id_8 !== null) ? report.money_type_id_8 : 0));
        money_9 = parseFloat(money_9) + parseFloat(((report.money_type_id_9 !== null) ? report.money_type_id_9 : 0));
        money_10 = parseFloat(money_10) + parseFloat(((report.money_type_id_10 !== null) ? report.money_type_id_10 : 0));
      }
      else {
        if (n > 1) {
          arr.push([
            { text: 'รหัสกิจกรรม : ' + project_name, style: 'tableHeader', alignment: 'left', colSpan: 5 },
            {},
            {},
            {},
            {},
            { text: currencyFormat((money_1 !== null) ? money_1 : 0), style: 'tableHeader', alignment: 'right' },
            { text: currencyFormat((money_2 !== null) ? money_2 : 0), style: 'tableHeader', alignment: 'right' },
            { text: currencyFormat((money_3 !== null) ? money_3 : 0), style: 'tableHeader', alignment: 'right' },
            { text: currencyFormat((money_7 !== null) ? money_7 : 0), style: 'tableHeader', alignment: 'right' },
            { text: currencyFormat((money_8 !== null) ? money_8 : 0), style: 'tableHeader', alignment: 'right' },
            { text: currencyFormat((money_9 !== null) ? money_9 : 0), style: 'tableHeader', alignment: 'right' },
            { text: currencyFormat((money_10 !== null) ? money_10 : 0), style: 'tableHeader', alignment: 'right' }
          ])
        }

        money_1 = 0;
        money_2 = 0;
        money_3 = 0;
        money_7 = 0;
        money_8 = 0;
        money_9 = 0;
        money_10 = 0;

        money_1 = parseFloat(money_1) + parseFloat(((report.money_type_id_1 !== null) ? report.money_type_id_1 : 0));
        money_2 = parseFloat(money_2) + parseFloat(((report.money_type_id_2 !== null) ? report.money_type_id_2 : 0));
        money_3 = parseFloat(money_3) + parseFloat(((report.money_type_id_3 !== null) ? report.money_type_id_3 : 0));
        money_7 = parseFloat(money_7) + parseFloat(((report.money_type_id_7 !== null) ? report.money_type_id_7 : 0));
        money_8 = parseFloat(money_8) + parseFloat(((report.money_type_id_8 !== null) ? report.money_type_id_8 : 0));
        money_9 = parseFloat(money_9) + parseFloat(((report.money_type_id_9 !== null) ? report.money_type_id_9 : 0));
        money_10 = parseFloat(money_10) + parseFloat(((report.money_type_id_10 !== null) ? report.money_type_id_10 : 0));


        arr.push([
          { text: n, style: 'table1', alignment: 'left' },
          { text: report.position_num, style: 'table1', alignment: 'center' },
          { text: report.prefix_name + report.fnamethai + " " + report.lnamethai, style: 'table1', alignment: 'left' },
          { text: report.project_activities_id, style: 'table1', alignment: 'center' },
          { text: report.position_name, style: 'table1', alignment: 'center' },
          { text: currencyFormat((report.money_type_id_1 !== null) ? report.money_type_id_1 : 0), style: 'table1', alignment: 'right' },
          { text: currencyFormat((report.money_type_id_2 !== null) ? report.money_type_id_2 : 0), style: 'table1', alignment: 'right' },
          { text: currencyFormat((report.money_type_id_3 !== null) ? report.money_type_id_3 : 0), style: 'table1', alignment: 'right' },
          { text: currencyFormat((report.money_type_id_7 !== null) ? report.money_type_id_7 : 0), style: 'table1', alignment: 'right' },
          { text: currencyFormat((report.money_type_id_8 !== null) ? report.money_type_id_8 : 0), style: 'table1', alignment: 'right' },
          { text: currencyFormat((report.money_type_id_9 !== null) ? report.money_type_id_9 : 0), style: 'table1', alignment: 'right' },
          { text: currencyFormat((report.money_type_id_10 !== null) ? report.money_type_id_10 : 0), style: 'table1', alignment: 'right' }
        ])
        if (n === reports.length) {
          arr.push([
            { text: 'รหัสกิจกรรม : ' + report.project_activities_id, style: 'tableHeader', alignment: 'left', colSpan: 5 },
            {},
            {},
            {},
            {},
            { text: currencyFormat((money_1 !== null) ? money_1 : 0), style: 'tableHeader', alignment: 'right' },
            { text: currencyFormat((money_2 !== null) ? money_2 : 0), style: 'tableHeader', alignment: 'right' },
            { text: currencyFormat((money_3 !== null) ? money_3 : 0), style: 'tableHeader', alignment: 'right' },
            { text: currencyFormat((money_7 !== null) ? money_7 : 0), style: 'tableHeader', alignment: 'right' },
            { text: currencyFormat((money_8 !== null) ? money_8 : 0), style: 'tableHeader', alignment: 'right' },
            { text: currencyFormat((money_9 !== null) ? money_9 : 0), style: 'tableHeader', alignment: 'right' },
            { text: currencyFormat((money_10 !== null) ? money_10 : 0), style: 'tableHeader', alignment: 'right' }
          ])
        }
        project_name = report.project_activities_id;
      }
      //รวมทั้งหมด
      total_money_1 = parseFloat(total_money_1) + parseFloat(((report.money_type_id_1 !== null) ? report.money_type_id_1 : 0));
      total_money_2 = parseFloat(total_money_2) + parseFloat(((report.money_type_id_2 !== null) ? report.money_type_id_2 : 0));
      total_money_3 = parseFloat(total_money_3) + parseFloat(((report.money_type_id_3 !== null) ? report.money_type_id_3 : 0));
      total_money_7 = parseFloat(total_money_7) + parseFloat(((report.money_type_id_7 !== null) ? report.money_type_id_7 : 0));
      total_money_8 = parseFloat(total_money_8) + parseFloat(((report.money_type_id_8 !== null) ? report.money_type_id_8 : 0));
      total_money_9 = parseFloat(total_money_9) + parseFloat(((report.money_type_id_9 !== null) ? report.money_type_id_9 : 0));
      total_money_10 = parseFloat(total_money_10) + parseFloat(((report.money_type_id_10 !== null) ? report.money_type_id_10 : 0));
      n++
    });
    arr.push([
      { text: 'รวมทั้งสิ้น', style: 'tableHeader', alignment: 'center', colSpan: 5 },
      {},
      {},
      {},
      {},
      { text: currencyFormat((total_money_1 !== null) ? total_money_1 : 0), style: 'tableHeader', alignment: 'right' },
      { text: currencyFormat((total_money_2 !== null) ? total_money_2 : 0), style: 'tableHeader', alignment: 'right' },
      { text: currencyFormat((total_money_3 !== null) ? total_money_3 : 0), style: 'tableHeader', alignment: 'right' },
      { text: currencyFormat((total_money_7 !== null) ? total_money_7 : 0), style: 'tableHeader', alignment: 'right' },
      { text: currencyFormat((total_money_8 !== null) ? total_money_8 : 0), style: 'tableHeader', alignment: 'right' },
      { text: currencyFormat((total_money_9 !== null) ? total_money_9 : 0), style: 'tableHeader', alignment: 'right' },
      { text: currencyFormat((total_money_10 !== null) ? total_money_10 : 0), style: 'tableHeader', alignment: 'right' }
    ])

    let docDefinition = {
      //watermark: { text: 'อยู่ระหว่างการปรับปรุงcolor: 'red', opacity: 0.3, bold: true, italics: true },
      /* userPassword: profile.person.citizen_id,
       ownerPassword: '1480700055058',*/
      pageSize: 'A4',
      pageOrientation: 'landscape',
      pageMargins: [20, 20, 20, 20],
      content: [
        {
          columns: [
            { width: 800, text: 'สรุปรายงานประจำเดือนลูกจ้างชั่วคราวเดือนรายวัน', style: 'header', alignment: 'center' },
          ]
        },
        {
          columns: [
            { width: 100, text: [] },
            { width: 55, text: [{ text: 'ส่วนราชการ', style: 'subheader', alignment: 'left' }] },
            { width: 130, text: [{ text: 'มหาวิทยาลัยราชภักสกลนคร', style: 'header', alignment: 'left' }] },
            { width: 30, text: [{ text: 'จังหวัด', style: 'subheader', alignment: 'left' }] },
            { width: 50, text: [{ text: 'สกลนคร', style: 'header', alignment: 'left' }] },
            { width: 45, text: [] },
            { width: 80, text: [{ text: 'ประจำเดือน', style: 'subheader', alignment: 'left' }] },
            { width: 80, text: [{ text: moment(budgetYears).format('MMMM'), style: 'header', alignment: 'left' }] },
            { width: 20, text: [{ text: 'พ.ศ.', style: 'subheader', alignment: 'left' }] },
            { width: 225, text: [{ text: parseInt(moment(budgetYears).format('YYYY')) + 543, style: 'header', alignment: 'left' }] }
          ]
        },
        {
          columns: [
            {
              table: {
                widths: [20, 30, 100, 140, 115, 50, 40, 40, 40, 40, 45, 35],
                //heights: [20, 400, 200, 200, 20, 20, 20, 20, 20],
                headerRows: 1,
                body: arr
              }
            }
          ]
        }
      ],
      defaultStyle: {
        font: 'THSarabunNew',
        fontSize: 14,
        columnGap: 10,
        lineHeight: 1.2
      },
      styles: {
        header: {
          fontSize: 16,
          bold: true,
        },
        header2: {
          fontSize: 26,
          bold: true
        },
        header3: {
          fontSize: 22,
          bold: true,
          decoration: 'underline',
        },
        tableExample: {
          margin: [0, 0, 0, 15]
        },
        tableHeader: {
          fontSize: 12,
          bold: true,
        },
        tableHeader2: {
          fontSize: 12,
          bold: true,
        },
        tableHeader3: {
          fontSize: 12,
          bold: true,
          decoration: 'underline',
        },
        table1: {
          fontSize: 12,
        },
        table2: {
          fontSize: 12,
        },
        subheader: {
          fontSize: 16,
        },
        quote: {
          italics: true
        },
        small: {
          fontSize: 10
        },
        awesome: {
          font: 'FontAwesome',
          fontSize: 14,
        }
      }
    };
    return docDefinition;
  }

  const clear_value = () => {
    setDka_detail('');
    setTax_value(0)
    setFinder_name('');
    setFinder_position('');
  }

  const set_value = (data) => {
    setDka_detail(data.dka_detail);
    setTax_value(data.tax_value)
    setFinder_name(data.Finder_name);
    setFinder_position(data.Finder_position);
  }

  const handleInputChange = async e => {
    const { name, value } = e.target;
    let dka_data = [];
    if (name === 'dka_id') {
      setDka_id(value);
      if (dka_years !== null && dka_years !== '') {
        dka_data = await loadEslipReportConfigByDkaId(value, dka_years, report.report_type_id)
        if (dka_data !== null) { if (dka_data) { set_value(dka_data) } }
        else { clear_value(); }
      }
    } else if (name === 'dka_years') {
      setDka_years(value)
      if (dka_id !== null && dka_id !== '') {
        dka_data = await loadEslipReportConfigByDkaId(dka_id, value, report.report_type_id)
        if (dka_data !== null) {
          if (dka_data) { set_value(dka_data) }
        } else { clear_value(); }
      }
    } else if (name === 'dka_detail') {
      setDka_detail(value)
    } else if (name === 'tax_value') {
      setTax_value(value)
    } else if (name === 'Finder_name') {
      setFinder_name(value)
    } else {
      setFinder_position(value)
    }
  }

  const addSlipconfig = () => {
    const values = {
      dka_id: dka_id,
      dka_years: dka_years,
      dka_detail: dka_detail,
      tax_value: tax_value,
      Finder_name: Finder_name,
      Finder_position: Finder_position,
      user_update: profile.person.citizen_id,
      report_type_id: report.report_type_id,
      report_status: '1'
    }
    saveData(values)
  }


  const saveData = async (value) => {
    try {
      const apiUrl = 'https://eslip.snru.ac.th/backend/api/reportData/saveData';
      const response = await axios.post(apiUrl, value);
      console.log(response)

      /*setSnackVariant('success');
      setSnackMessage('บันทึกข้อมูลแแล้ว');
      setOpenSnack(true);*/
    } catch (error) {
      if (error.response.data.error.status === 403) {
        const apiUrl = 'https://eslip.snru.ac.th/backend/api/reportData/updateData';
        const response = await axios.post(apiUrl, value);
        console.log(response)
      }
      else {
        console.log(error.response.data.error.message)
      }
      /*setSnackVariant('error');
      setSnackMessage(error.response.data.error.message)
      setOpenSnack(true);*/
    }
  }

  let thaiyear = parseInt(moment(budgetYears).locale("th", localization).format('YYYY')) + 543;

  return (
    <div>
      <Card
        {...rest}
        className={clsx(classes.root, className)}
      >
        <CardContent>
          <div className={classes.imageContainer}>
            <img
              alt="Product"
              className={classes.image}
              src={report.imageUrl}
            />
          </div>
          <Typography
            align="center"
            gutterBottom
            variant="h4"
          >
            {report.title}
          </Typography>
          <Typography
            align="center"
            variant="body1"
          >
            {report.description}
          </Typography>
        </CardContent>
        <Divider />
        <CardActions>
          <Grid
            container
            justify="space-between"
          >
            <Grid
              className={classes.statsItem}
              item
            >
              <IconButton color="primary" component="span" onClick={event => { printSlip(report.report_type_id) }} >
                <GetAppIcon className={classes.statsIcon} />
              </IconButton>

              <Typography
                display="inline"
                variant="body2"
              >
                {report.totalDownloads + " " + moment(budgetYears).locale("th", localization).format('MMMM') + " " + thaiyear}
              </Typography>
            </Grid>
            <Grid
              className={classes.statsItem}
              item
            >
              <IconButton color="primary" component="span" onClick={event => { handleClickOpen() }} >
                <Description className={classes.statsIcon} />
              </IconButton>

              <Typography
                display="inline"
                variant="body2"
              >
                แก้ไขข้อมูล
            </Typography>
            </Grid>
          </Grid>
        </CardActions>
      </Card>
      <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">ข้อมูลรายละเอียดฎีกา</DialogTitle>
        <DialogContent>
          <DialogContentText>
            รายละเอียดที่จะแสดงใน ฎิกา สามารถแก้ไข และเพิ่มได้ในข้อมูลด้านล่าง
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            name="dka_id"
            label="ฎีกาเลขที่"
            type="text"
            onChange={e => handleInputChange(e)}
            value={dka_id}
            InputLabelProps={{
              shrink: true,
            }}
          />
          <TextField
            autoFocus
            margin="dense"
            name="dka_years"
            label="ปี"
            type="number"

            onChange={e => handleInputChange(e)}
            value={dka_years}
            InputLabelProps={{
              shrink: true,
            }}
          />
          <TextField
            name="dka_detail"
            label="รายละเอียดเบิกคำสั่ง"
            placeholder="กรอกรายละเอียด"
            multiline
            onChange={e => handleInputChange(e)}
            value={dka_detail}
            InputLabelProps={{
              shrink: true,
            }}
            margin="normal"
            fullWidth
          />
          <TextField
            name="tax_value"
            label="หักภาษี ณ ที่จ่าย"
            type="number"
            onChange={handleInputChange}
            value={tax_value}
            InputLabelProps={{
              shrink: true,
            }}
            margin="normal"
            fullWidth
          />
          <TextField
            autoFocus
            margin="dense"
            name="Finder_name"
            label="ชื่อผู้เบิก"
            type="text"
            onChange={handleInputChange}
            value={Finder_name}
            InputLabelProps={{
              shrink: true,
            }}
            fullWidth
          />
          <TextField
            autoFocus
            margin="dense"
            name="Finder_position"
            label="ตำแหน่งผู้เบิก"
            type="text"
            onChange={handleInputChange}
            value={Finder_position}
            InputLabelProps={{
              shrink: true,
            }}
            fullWidth
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            ยกเลิก
          </Button>
          <Button onClick={addSlipconfig} color="primary">
            บันทึกข้อมูล
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

ReportList.propTypes = {
  className: PropTypes.string,
  report: PropTypes.object.isRequired,
  budgetYears: PropTypes.string,
  typePersons: PropTypes.array
};

export default ReportList;
